import React, { useEffect, useState } from 'react'
import LoadingScreen from '../Common/LoadingScreen'
import Form from './Form'
import Info from '../Common/Info'
import { createBadge, getBadges } from '../../store/actions/badge'
import { connect } from 'react-redux'

function CreateBadge({ badge, createBadge, getBadges }) {
  const [formObj, setFormObj] = useState({
    state: 'idle',
    title: '',
    version: '',
    issuedBy: '',
    authorizedBy: '',
    description: { counter: 0, value: '', status: '', maxCount: 500 },
    skills: { counter: 0, value: '', status: '', maxCount: 250 },
    type: 'Select type of the badge',
    level: 'Select level of the badge',
    time: '',
    expirationYears: 0,
    criteria: '',
    image: [],
  })

  const { state } = formObj
  const { creatBadgeSuccess, createBadgeError } = badge

  useEffect(() => {
    getBadges(formObj, setFormObj)
  }, [getBadges])

  const onChangeHandler = (e) => {
    const fieldValue = e.target.value
    const fieldName = e.target.name
    setFormObj((data) => ({
      ...data,
      [fieldName]: fieldValue,
    }))
  }

  const textAreaHandler = (e) => {
    const fieldName = e.target.name
    const fieldValue = e.target.value
    if (fieldValue.length > formObj[fieldName].maxCount) {
      setFormObj((data) => ({
        ...data,
        [fieldName]: {
          value: data[fieldName].value,
          counter: data[fieldName].value.length,
          status: 'is-invalid',
          maxCount: data[fieldName].maxCount,
        },
      }))
      return
    }
    setFormObj((data) => ({
      ...data,
      [fieldName]: {
        counter: fieldValue.length,
        status: '',
        value: fieldValue,
        maxCount: data[fieldName].maxCount,
      },
    }))
  }

  const formSubmitHandler = () => {
    // e.preventDefault()
    createBadge(formObj, setFormObj)
  }

  return (
    <div id='CreateBadge' className=''>
      {state !== 'idle' && <LoadingScreen />}
      <h4 className='ps-2 ps-md-2 mt-4 title'>Create a new Badge</h4>
      {creatBadgeSuccess && <Info messages={['Badge Created Successfully']} alertType='alert-success' />}
      <Info messages={[...createBadgeError]} alertType='alert-danger' />
      <div className='ps-2 ps-md-2 mt-5 container-fluid'>
        <Form
          formObj={formObj}
          setFormObj={setFormObj}
          formSubmitHandler={formSubmitHandler}
          textAreaHandler={textAreaHandler}
          onChangeHandler={onChangeHandler}
        />
      </div>
    </div>
  )
}

const mapStateToProps = ({ badge }) => ({ badge })
export default connect(mapStateToProps, { createBadge, getBadges })(CreateBadge)
